import { render, staticRenderFns } from "./DownloadTileList.vue?vue&type=template&id=6a23958a&scoped=true"
import script from "./DownloadTileList.vue?vue&type=script&lang=js"
export * from "./DownloadTileList.vue?vue&type=script&lang=js"
import style0 from "./DownloadTileList.vue?vue&type=style&index=0&id=6a23958a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a23958a",
  null
  
)

export default component.exports